<template>
  <div class="p-fluid">
    <div class="p-col-12 p-lg-12">
      <div class="card card-w-title">
        <div class="manager-title-custom">Chi tiết #{{code}}</div>
        <div>
            <div class="button-container">
                <!-- <Button label="Quay lại" @click="backToList()" class="p-button-warning return-style-button" /> -->
                <Button v-if="show_edit==true" label="Chỉnh sửa" @click="goEdit()" class="" />
                <Button v-if="show_duyet_atw==true" label="Duyệt ATW" @click="showduyetATW()" class="" />
                <Button v-if="show_rut==true" label="Rút giấy phép" @click="showRutGiayPhep()" class="p-button-disa" />
                <Button v-if="show_duyet_rut==true" label="Duyệt rút giấy phép" @click="showDuyetRut()" class="" />
                <Button v-if="show_gia_han==true" label="Gia hạn giấy phép" @click="showGiaHan()" class="p-button-warning return-style-button" />
                <Button v-if="show_tai==true" label="Tải giấy phép" @click="DownloadPDF()" class="p-button-warning return-style-button" />
                <Button v-if="show_duyet_gia_han==true" label="Duyệt gia hạn" @click="showDuyetGiaHan()" class="" />
                <Button v-if="show_hoan_thanh==true" label="Hoàn thành" @click="goEvaluate()" class="" />
                <Button v-if="show_hoan_thanh_lai==true" label="Chỉnh sửa đánh giá" @click="goEvaluate()" class="" />
                <Button v-if="show_duyet_hoan_thanh==true" label="Duyệt hoàn thành giấy phép" @click="showDuyetHoanThanh()" class="" />
                <Button v-if="show_dong==true" label="Đóng ATW" @click="showDong()" class="" />
                <Button v-if="show_duyet_dong==true" label="Duyệt đóng ATW" @click="showDuyetDong()" class="" />
            </div>
            <div class="" style="padding-top:8px;">
                <div class="accordion-item">
                    <label @click="toggleIcon(1)" style="margin:0px;" class="accordion-label">
                        <i style="width : 25px;" :class="show_1 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                        <span>Thông tin chung</span>
                    </label>
                    <div class="accordion-content" v-show="show_1 == true">
                        <div class="f-grid-v">
                            <div class="f-grid-col-v">
                                <div class="container-tpl">
                                    <div class="left-cs">Công ty</div>
                                    <div class="right-cs">{{company?.name}}</div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs">Gói công việc SRA</div>
                                    <div class="right-cs" v-html="sra_html"></div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs">Thời gian thực hiện</div>
                                    <div class="right-cs">{{data_date_text}}</div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs">Thời gian hiệu lực</div>
                                    <div class="right-cs">{{data_expiration_text}}</div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs">Trạng thái</div>
                                    <div class="right-cs">
                                        <span v-html="status_text"></span>
                                        <!-- <span v-if="status=='REJECTED'" @click="viewNote()" style="color:#007bff;text-decoration: underline;cursor: pointer;padding-left: 4px;">Xem lý do</span> -->
                                    </div>
                                </div>
                            </div>
                            <div class="f-grid-col-v">
                                <div class="container-tpl">
                                    <div class="left-cs-2">Duyệt cấp 1</div>
                                    <div class="right-cs">{{fullname_c1}}</div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs-2">Duyệt cấp 2</div>
                                    <div class="right-cs">{{fullname_c2}}</div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs-2">Giám sát</div>
                                    <div class="right-cs">{{supervisor_text}}</div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs-2">Nhà thầu</div>
                                    <div class="right-cs" v-html="contractor_html"></div>
                                </div>
                                <div class="container-tpl">
                                    <div class="left-cs-2">Người liên quan</div>
                                    <div class="right-cs">{{related_text}}</div>
                                </div>
                            </div>
                        </div>
                        <div class="accordion-content">
                            <div class="f-grid-col-v2">
                                <div class="container-tpl-v2">
                                    <div class="titel-cs">Mô tả công việc</div>
                                    <div class="" v-html="description"></div>
                                    <hr>
                                    <div class="titel-cs">Vị trí</div>
                                    <div class="">{{factory_areas_text}}</div>
                                    <div class="">{{address}}</div>
                                    <br>
                                    <div class="titel-cs">Những mối nguy liên quan</div>
                                    <div class="" v-for="(item, index) in danger_text" :key="index">- {{item}}</div>
                                    <br>
                                    <div class="titel-cs">Các biện pháp kiểm soát đề nghị</div>
                                    <div class="" v-html="control_measures_text"></div>
                                </div>
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <div class="" style="padding-top:8px;">
                <div class="accordion-item">
                    <label @click="toggleIcon(2)" style="margin:0px;" class="accordion-label">
                        <i style="width : 25px;" :class="show_2 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                        <span>Theo dõi hành động</span>
                    </label>
                    <div class="accordion-content" v-show="show_2 == true">
                        <div class="accordion-content" id="status_history">
                            <div class="f-grid-col-v2">
                                <Timeline :value="history_status">
                                    <template #marker="slotProps">
                                        <div v-if="slotProps.index == 0">
                                        <span class="custom-marker shadow-2">
                                            <i class="fa fa-circle-o active-cus"></i>
                                        </span>
                                        </div>
                                    </template>
                                    <template #content="slotProps">
                                        <div v-if="slotProps.index==0" class="text-status-first">
                                            {{slotProps.item.text_status}}
                                        </div>
                                        <div v-else class="text-status">
                                            {{slotProps.item.text_status}}
                                        </div>
                                        <div class="text-date-name">
                                            {{slotProps.item.text_date_name}}
                                        </div>
                                        <div v-if="slotProps.item.note !==''" class="text-date-name">
                                            {{slotProps.item.note}}
                                        </div>
                                    </template>
                                </Timeline>
                                <Button style="width:200px;" v-if="showLoadMore" label="Xem thêm" @click="showAllEvents" />
                            </div>
                        </div>
                        <br>
                    </div>
                </div>
            </div>
            <div v-if="show_dgnt==true" class="" style="padding-top:8px;">
                <div class="accordion-item">
                    <label @click="toggleIcon(3)" style="margin:0px;" class="accordion-label">
                        <i style="width : 25px;" :class="show_3 == true ? 'fa fa-chevron-down' : 'fa fa-chevron-right'"></i>
                        <span>Đánh giá nhà thầu</span>
                    </label>
                    <div class="accordion-content" v-show="show_3 == true">
                        <div class="accordion-content">
                            <div class="f-grid-col-v2">
                              <table id="tb_dg">
                                <tr>
                                  <th style="text-align:left !important;">An toàn</th>
                                  <th style="text-align:left !important;">Chất lượng dịch vụ</th>
                                  <th style="text-align:left !important;">Tiếp tục sử dụng cho lần sau</th>
                                </tr>
                                <tr v-for="(item, index) in list_dgnt" :key="index">
                                  <td>{{item.safe_value_txt}}</td>
                                  <td>{{item.quality_value_txt}}</td>
                                  <td>{{item.continue_value_txt}}</td>
                                </tr>
                              </table>
                            </div>
                        </div>
                        
                        <div class="f-grid-col-v2">
                          <div class="">
                              <div class="danhgianote-cs">Ghi chú</div>
                              <div style="white-space: pre-wrap;" v-html='note_danh_gia'></div>
                          </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
      </div>
    </div>
    <Dialog class="custom-dialog" style="" :header="title_header_dialog" :visible.sync="showduyet" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <div style="width: 400px;max-width:400px;">
        <span>Bạn xác nhận đã xem thông tin và cập nhật trạng thái cho giấy phép làm việc này:</span>
      </div>
      <div style="padding-top: 4px;">
        <div v-if="data_status.status=='APPROVED'" style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
        </div>
        <div v-else style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
        </div>
      </div>
      <div v-if="data_status.status=='REJECTED'" style="padding-top: 6px;">
        <Textarea style="width:100%" v-model="data_status.note" type="text" rows="2" placeholder="Nhập lý do từ chối tại đây..."/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showduyet = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="DuyetATW()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog style="" :header="title_header_dialog_GH" :visible.sync="showGHDialog" :contentStyle="{overflow: 'visible', position: 'relative'}" :modal="true">
      <div style="width: 400px;max-width:400px;"> </div>
      <div>
        <label class="txt-left">Gói công việc SRA</label>
        <InputText disabled v-model="sra_name" type="text" class="cs-input input-text-box"/>
      </div>
      <div>
        <label class="txt-left">Nhà thầu</label>
        <InputText disabled v-model="contractor_name" type="text" class="cs-input input-text-box"/>
      </div>
      <div>
        <label class="txt-left">Thời gian thực hiện từ - đến</label>
        <Calendar disabled v-model="sra_data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
      </div>
      <div>
        <label class="txt-left">Hiệu lực giấy phép từ - đến</label>
        <Calendar disabled v-model="expiration_data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
      </div>
      <div>
        <label class="txt-left required">Gia hạn đến</label>
        <Calendar style="position: relative;" v-model="expiration_date" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showGHDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="saveGiaHan()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog class="custom-dialog" style="" :header="title_duyet_gia_han" :visible.sync="showduyetgiahanDialog" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <div style="">
        <label class="txt-left">Gia hạn đến</label>
        <Calendar disabled v-model="extend_date_show" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY"/>
      </div>
      <div style="padding-top: 4px;">
        <div v-if="data_status.status=='APPROVED'" style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
        </div>
        <div v-else style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
        </div>
      </div>
      <div v-if="data_status.status=='REJECTED'" style="padding-top: 6px;">
        <Textarea style="width:100%" v-model="data_status.note" type="text" rows="2" placeholder="Nhập lý do từ chối tại đây..."/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showduyetgiahanDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="SaveDuyetGiaHan()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog style="" :header="title_header_dialog_RGP" :visible.sync="showRGPDialog" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <div style="width: 400px;max-width:400px;"> </div>
      <div>
        <label class="txt-left">Gói công việc SRA</label>
        <InputText disabled v-model="sra_name" type="text" class="cs-input input-text-box"/>
      </div>
      <div>
        <label class="txt-left">Nhà thầu</label>
        <InputText disabled v-model="contractor_name" type="text" class="cs-input input-text-box"/>
      </div>
      <div>
        <label class="txt-left">Thời gian thực hiện từ - đến</label>
        <Calendar disabled v-model="sra_data_date" selectionMode="range" dateFormat="dd/mm/yy" :showIcon="true" :manualInput="false" :showButtonBar="true" placeholder="DD/MM/YYYY - DD/MM/YYYY"/>
      </div>
      <div>
        <label class="txt-left required">Lý do</label>
        <Textarea style="width:100%" v-model="note_rut" type="text" rows="2" placeholder="Nhập lý do từ chối tại đây..."/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showRGPDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="saveRut()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog class="custom-dialog" style="" :header="title_duyet_rut" :visible.sync="showduyetrutDialog" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <!-- <div style=""></div> -->
      <div style="padding-top: 4px;">
        <div v-if="data_status.status=='APPROVED'" style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
        </div>
        <div v-else style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
        </div>
      </div>
      <div v-if="data_status.status=='REJECTED'" style="padding-top: 6px;">
        <Textarea style="width:100%" v-model="data_status.note" type="text" rows="2" placeholder="Nhập lý do từ chối tại đây..."/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showduyetrutDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="SaveDuyetRut()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog class="custom-dialog" style="" :header="title_duyet_hoan_thanh" :visible.sync="showduyethoanthanhDialog" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <div style="padding-top: 4px;">
        <div v-if="data_status.status=='APPROVED'" style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
        </div>
        <div v-else style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
        </div>
      </div>
      <div v-if="data_status.status=='REJECTED'" style="padding-top: 6px;">
        <Textarea style="width:100%" v-model="data_status.note" type="text" rows="2" placeholder="Nhập lý do từ chối tại đây..."/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showduyethoanthanhDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="SaveDuyetHoanThanh()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog class="custom-dialog" style="" :header="title_header_dialog_dong" :visible.sync="showdongDialog" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <div style="padding-top: 4px;">
        Ban có chắc chắn muốn đóng ATW này không?
      </div>
      <template #footer>
        <Button label="Hủy" @click="showdongDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="saveDong()" icon="pi pi-check" class="" />
      </template>
    </Dialog>

    <Dialog class="custom-dialog" style="" :header="title_header_dialog_duyet_dong" :visible.sync="showduyetdongDialog" :contentStyle="{overflow: 'visible',overflowY: 'auto'}" :modal="true">
      <div style="padding-top: 4px;">
        <div v-if="data_status.status=='APPROVED'" style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
        </div>
        <div v-else style="display:flex">
          <Button label="Duyệt" @click="clickApprove()" class="" style="margin:2px;color:#666666;background-color: #F3F4F7;border: 1px solid #F3F4F7;"/>
          <Button label="Từ chối" @click="clickReject()" class="" style="margin:2px;margin:2px;color:#0086C4;background-color:#E5F3FA;font-weight: 700;"/>
        </div>
      </div>
      <div v-if="data_status.status=='REJECTED'" style="padding-top: 6px;">
        <Textarea style="width:100%" v-model="data_status.note" type="text" rows="2" placeholder="Nhập lý do từ chối tại đây..."/>
      </div>
      <template #footer>
        <Button label="Hủy" @click="showduyetdongDialog = false" icon="pi pi-times" class="p-button-disa" />
        <Button label="Xác nhận" @click="saveDuyetDong()" icon="pi pi-check" class="" />
      </template>
    </Dialog>
  </div>
</template>

<script>
import ApiRepository from "@/core/ApiRepository";
import moment from "moment-timezone";
import jq from 'jquery';
export default {
  components: {
  },
  data() {
    return {
        show_button : false,
        show_duyet_atw : false,
        code : '',
        users: null,
        show_cancel : false,
        show_edit : false,
        show_approved : false,
        mode: 'view',
        model: {},
        page_transaction:null,
        company_id: null,
        view_id : null,
        name : '',
        show_1 : true,
        show_2 : true,
        show_3 : true,
        company : null,
        factory : null,
        areas : [],
        areas_text : '',
        data_date_text : '',
        data_expiration_text : '',
        status_text : '',
        status : '',
        fullname_c1 : '',
        fullname_c2 : '',
        supervisor_text : '',
        contractor_html : '',
        description : '',
        danger_text : [],
        control_measures_text : '',
        sra_html : '',
        ep_areas : [],
        is_load_data : false,
        related_text : '',
        address : '',
        factory_areas_text : '',
        history_status : [],
        uid_c1 : null,
        uid_c2 : null,
        showduyet : false,
        show_rut : false,
        show_tai : false,
        show_gia_han : false,
        show_hoan_thanh : false,
        title_header_dialog : 'Duyệt giấy phép làm việc',
        data_status: {
          status : '',
          note : ''
        },
        showGHDialog : false,
        title_header_dialog_GH : 'Gia hạn giấy phép',
        sra_name : '',
        contractor_name : '',
        data_date : null,
        expiration_date : null,
        sra_data_date : [],
        expiration_data_date : [],
        title_duyet_gia_han : '',
        showduyetgiahanDialog : false,
        show_duyet_gia_han : false,
        extend_date_show : null,
        showRGPDialog : false,
        title_header_dialog_RGP : 'Rút giấy phép',
        note_rut : '',
        show_duyet_rut : false,
        title_duyet_rut : 'Duyệt rút giấy phép',
        showduyetrutDialog : false,
        show_duyet_hoan_thanh : false,
        title_duyet_hoan_thanh : 'Duyệt hoàn thành',
        showduyethoanthanhDialog : false,
        list_dgnt : [],
        show_hoan_thanh_lai : false,
        show_dong : false,
        show_duyet_dong : false,
        showdongDialog : false,
        title_header_dialog_dong : 'Đóng #',
        title_header_dialog_duyet_dong : 'Duyệt đóng #',
        showduyetdongDialog : false,
        show_dgnt : false,
        showLoadMore : false,
        allEvents : [],
        displayedEvents : [],
        note_danh_gia : '',
    }
  },
  async mounted () {
    if (!this.$commonFuction.isEmpty(this.$route.query)){
      if (!this.$commonFuction.isEmpty(this.$route.query.company_id)){
        this.company_id = this.$route.query.company_id;
      }
    }
    if (this.$route.params.id !== undefined) {
        this.view_id = this.$route.params.id
        await this.getData(this.$route.params.id);
        if (this.model !== undefined && Object.keys(this.model).length > 0) {
            console.log("this.model===",this.model)
            this.code = this.model.code
            this.company = this.model.company
            this.company_id = this.model.company.id
            this.factory = this.model.factory
            var sra_html = ''
            if(this.model.sra){
                if (this.$store.getters.controllers?.list_sra && this.$store.getters.controllers?.list_sra.includes('view')) {
                    sra_html = '<a class="css-underline" href="/admin/list-sra/view/'+this.model.sra.id+'?company_id='+this.company.id+'">'+this.model.sra.name+'</a>'
                }else{
                    sra_html = '<span>'+this.model.sra.name+'</span>'
                }
                this.sra_name = this.model.sra.name
            }
            this.sra_html = sra_html
            var data_date_text = ''
            if(this.model.sra_date_start){
                data_date_text = moment(this.model.sra_date_start).format("DD/MM/YYYY")
            }else{data_date_text = '?'}
            if(this.model.sra_date_end){
                data_date_text += ' - '+moment(this.model.sra_date_end).format("DD/MM/YYYY")
            }else{data_date_text += ' - ?'}
            this.data_date_text = data_date_text
            var data_expiration_text = ''
            if(this.model.expiration_start){
                data_expiration_text = moment(this.model.expiration_start).format("DD/MM/YYYY")
            }else{data_expiration_text = '?'}
            if(this.model.expiration_end){
                data_expiration_text += ' - '+moment(this.model.expiration_end).format("DD/MM/YYYY")
            }else{data_expiration_text += ' - ?'}
            this.extend_date_show = this.model.extend_date ? new Date(this.model.extend_date) : null
            this.data_expiration_text = data_expiration_text
            this.uid_c1 = this.model.uid_c1 ?? null
            this.uid_c2 = this.model.uid_c2 ?? null
            var supervisor_text = ''
            var supervisor_ids = []
            if(this.model.atw_supervisor && this.model.atw_supervisor.length > 0){
                for (let i = 0; i < this.model.atw_supervisor.length; i++) {
                    supervisor_ids.push(this.model.atw_supervisor[i].uid)
                    if(supervisor_text !== ''){
                        supervisor_text += '; '+this.model.atw_supervisor[i].fullname
                    }else{
                        supervisor_text = this.model.atw_supervisor[i].fullname
                    }
                }
            }
            this.supervisor_text = supervisor_text
            this.getStatus(this.model.status,this.model.uid_c1,this.model.uid_c2,this.model.created_by,supervisor_ids)
            this.reject_note = this.model.reject_note
            this.fullname_c1 = this.model.fullname_c1 ?? ''
            this.fullname_c2 = this.model.fullname_c2 ?? ''
            
            var contractor_html = '-'
            if(this.model.contractor){
                if (this.$store.getters.controllers?.list_contractor && this.$store.getters.controllers?.list_contractor.includes('edit')) {
                    contractor_html = '<a class="css-underline" href="/admin/list-contractor/edit/'+this.model.contractor_id+'?company_id='+this.company.id+'">['+this.model.contractor.code+'] '+this.model.contractor.name+'</a>'
                }else{
                    contractor_html = '<span>['+this.model.contractor.code+'] '+this.model.contractor.name+'</span>'
                }
                this.contractor_name = '['+this.model.contractor.code+'] '+this.model.contractor.name
            }
            this.contractor_html = contractor_html

            var related_text = ''
            if(this.model.atw_users_related && this.model.atw_users_related.length > 0){
                for (let i = 0; i < this.model.atw_users_related.length; i++) {
                    if(related_text !== ''){
                        related_text += '; '+this.model.atw_users_related[i].fullname
                    }else{
                        related_text = this.model.atw_users_related[i].fullname
                    }
                }
            }
            this.related_text = related_text
            // this.description = this.model.description ?? ''
            this.description = this.formatTextToHtml(this.model.description)
            var factory_areas_text = ''
            if(this.model.factory){
                factory_areas_text = this.model.factory.name
            }
            var areas_text = ''
            var areas = []
            if(this.model.atw_areas && this.model.atw_areas.length > 0){
                for (let i = 0; i < this.model.atw_areas.length; i++) {
                    areas.push(this.model.atw_areas[i])
                    if(areas_text !== ''){
                        areas_text += '; '+this.model.atw_areas[i].name
                    }else{
                        areas_text = this.model.atw_areas[i].name
                    }
                }
            }
            this.factory_areas_text = areas_text ? factory_areas_text + ' - ' + areas_text : factory_areas_text
            this.areas = areas
            this.address = this.model.address ?? ''
            if(this.model.atw_danger && this.model.atw_danger.length > 0){
                for (let i = 0; i < this.model.atw_danger.length; i++) {
                    const e = this.model.atw_danger[i];
                    if(e.danger && e.danger.name){
                        this.danger_text.push(e.danger.name)
                    }
                }
            }
            // this.control_measures_text = this.model.control_measures
            this.control_measures_text = this.formatTextToHtml(this.model.control_measures)
            if(this.model.sra_date_start && this.model.sra_date_end){
              this.sra_data_date = [new Date(this.model.sra_date_start), new Date(this.model.sra_date_end)]
            }
            if(this.model.expiration_start && this.model.expiration_end){
              this.expiration_data_date = [new Date(this.model.expiration_start), new Date(this.model.expiration_end)]
            }
            if(this.model.atw_contractor_evaluate){
              let safe_value_txt = ''
              let quality_value_txt = ''
              let continue_value_txt = ''
              if(this.model.atw_contractor_evaluate.safe_value == 1){
                safe_value_txt = 'Rất tệ'
              }else if(this.model.atw_contractor_evaluate.safe_value == 2){
                safe_value_txt = 'Tệ'
              }else if(this.model.atw_contractor_evaluate.safe_value == 3){
                safe_value_txt = 'Hoàn thành'
              }else if(this.model.atw_contractor_evaluate.safe_value == 4){
                safe_value_txt = 'Tốt'
              }else if(this.model.atw_contractor_evaluate.safe_value == 5){
                safe_value_txt = 'Rất tốt'
              }
              if(this.model.atw_contractor_evaluate.quality_value == 1){
                quality_value_txt = 'Rất tệ'
              }else if(this.model.atw_contractor_evaluate.quality_value == 2){
                quality_value_txt = 'Tệ'
              }else if(this.model.atw_contractor_evaluate.quality_value == 3){
                quality_value_txt = 'Hoàn thành'
              }else if(this.model.atw_contractor_evaluate.quality_value == 4){
                quality_value_txt = 'Tốt'
              }else if(this.model.atw_contractor_evaluate.quality_value == 5){
                quality_value_txt = 'Rất tốt'
              }
              if(this.model.atw_contractor_evaluate.continue_value == 1){
                continue_value_txt = 'Không tiếp tục'
              }else if(this.model.atw_contractor_evaluate.continue_value == 2){
                continue_value_txt = 'Tiếp tục'
              }
              let tmp_ls = {
                safe_value_txt : safe_value_txt,
                quality_value_txt : quality_value_txt,
                continue_value_txt : continue_value_txt
              }
              this.note_danh_gia = this.model.atw_contractor_evaluate.note ?? ''
              this.list_dgnt.push(tmp_ls)
              this.show_dgnt = true
            }
        }
        this.getListHistory()
    }
  },
  watch : {  
  },
  methods: {
    async getStatus(status,uid_c1=null,uid_c2=null,created_by=null,ids_giam_sat=[]){
        this.status = status;
        var text = ''
        var type_login = this.$store.getters.type ? this.$store.getters.type : null;
        var show_edit = false
        var show_duyet_atw = false
        var show_rut = false
        var show_gia_han = false
        var show_tai = false
        var show_hoan_thanh = false
        var show_duyet_gia_han = false
        var show_duyet_rut = false
        var show_duyet_hoan_thanh = false
        var show_hoan_thanh_lai = false
        var show_chinh_sua = false
        var show_dong = false
        var show_duyet_dong = false 
        if(status == 'WAITTING'){ 
          text = 'Chờ duyệt'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_edit = true;
            show_duyet_atw = true;
          }else {
            if(uid_c1 && uid_c1 == this.$store.getters.user){
              show_duyet_atw = true; 
            }
          }
          if(created_by == this.$store.getters.user){
            show_edit = true;
          }
        }else if(status == 'APPROVED_LV1'){
          text = 'Duyệt cấp 1'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_duyet_atw = true;
          }else {
            if(uid_c2 && uid_c2 == this.$store.getters.user){
              show_duyet_atw = true; 
            }
          }
        }
        else if(status == 'APPROVED'){
          text = 'Đã duyệt'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_rut = true;
            show_gia_han = true;
            show_hoan_thanh = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_rut = true;
            show_hoan_thanh = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_gia_han = true;
          }
          show_tai = true;
        }
        else if(status == 'EXTEND_WAITTING'){
          text = 'Chờ gia hạn'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_rut = true;
            show_duyet_gia_han = true;
            show_hoan_thanh = true;
          }else if(uid_c1 == this.$store.getters.user){
            show_duyet_gia_han = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_duyet_gia_han = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_rut = true;
          }
          show_tai = true;
        }
        else if(status == 'REJECTED_EXTEND'){
          text = 'Từ chối gia hạn'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_rut = true;
            show_gia_han = true;
            show_hoan_thanh = true;
          }else if(uid_c1 == this.$store.getters.user){
            console.log('c1')
            // show_gia_han = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_gia_han = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_rut = true;
          }
          show_tai = true;
        }else if(status == 'EXTEND_LV1'){
          text = 'Đã duyệt gia hạn 1 cấp'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_rut = true;
            show_duyet_gia_han = true;
            show_hoan_thanh = true;
          }else if(uid_c2 == this.$store.getters.user){
            show_duyet_gia_han = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_duyet_gia_han = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_rut = true;
          }
          show_tai = true;
        }else if(status == 'EXTEND'){
          text = 'Đã gia hạn'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_rut = true;
            show_gia_han = true;
            show_hoan_thanh = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_gia_han = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_rut = true;
          }
          show_tai = true;
        }
        else if(status == 'WITHDRAW_WAITTING'){
          text = 'Chờ duyệt rút giấy phép'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_gia_han = true;
            show_duyet_rut = true;
            show_hoan_thanh = true;
          }else if(uid_c1 == this.$store.getters.user){
            show_duyet_rut = true;
          }
          if(created_by == this.$store.getters.user){
            show_gia_han = true;
            show_duyet_rut = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_gia_han = true;
          }
          show_tai = true;
        
        }
        else if(status == 'REJECTED_WITHDRAW'){
          text = 'Từ chối rút giấy phép'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_gia_han = true;
            show_rut = true;
            show_hoan_thanh = true;
          }else if(uid_c1 == this.$store.getters.user){
            console.log('c1')
            // show_gia_han = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_gia_han = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_rut = true;
          }
          show_tai = true;
        }else if(status == 'WITHDRAW_LV1'){
          text = 'Đã duyệt rút 1 cấp'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_gia_han = true;
            show_duyet_rut = true;
            show_hoan_thanh = true;
          }else if(uid_c2 == this.$store.getters.user){
            show_duyet_rut = true;
          }
          if(created_by == this.$store.getters.user){
            show_gia_han = true;
            show_duyet_rut = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_gia_han = true;
          }
          show_tai = true;
        }else if(status == 'WITHDRAW'){
          text = 'Rút giấy phép'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            // show_gia_han = true;
            // show_rut = true;
            // show_hoan_thanh = true;
          }
          if(created_by == this.$store.getters.user){
            // show_gia_han = true;
            // show_rut = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            // show_hoan_thanh = true;
            // show_gia_han = true;
          }
          show_tai = false;
        }
        else if(status == 'DONE_WAITTING'){
          text = 'Chờ duyệt hoàn thành'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_gia_han = true;
            show_rut = true;
            show_duyet_hoan_thanh = true;
          }else if(uid_c1 == this.$store.getters.user){
            show_duyet_hoan_thanh = true;
          }
          if(created_by == this.$store.getters.user){
            show_gia_han = true;
            show_rut = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_gia_han = true;
            // show_rut = true;
          }
          show_tai = true;
        }
        else if(status == 'REJECTED_DONE'){
          text = 'Từ chối hoàn thành'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_gia_han = true;
            show_rut = true;
            show_hoan_thanh_lai = true;
          }else if(uid_c1 == this.$store.getters.user){
            console.log('c1')
            // show_gia_han = true;
          }
          if(created_by == this.$store.getters.user){
            show_rut = true;
            show_gia_han = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh_lai = true;
            show_rut = true;
            show_gia_han = true;
          }
          show_tai = true;
        }else if(status == 'DONE_LV1'){
          text = 'Duyệt hoàn thành cấp 1'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_gia_han = true;
            show_rut = true;
            show_duyet_hoan_thanh = true;
          }else if(uid_c2 == this.$store.getters.user){
            show_duyet_hoan_thanh = true;
          }
          if(created_by == this.$store.getters.user){
            show_gia_han = true;
            show_rut = true;
          }
          let check_giam_sat = this.checkGiamSat(ids_giam_sat)
          if(check_giam_sat == true){
            show_hoan_thanh = true;
            show_gia_han = true;
            // show_rut = true;
          }
          show_tai = true;
        }
        else if(status == 'DONE'){
          text = 'Hoàn thành'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            // show_chinh_sua = true;
            show_dong = true;
          }
          if(created_by == this.$store.getters.user){ 
            // show_chinh_sua = true;
            show_dong = true;
          }
          show_tai = true;
        }
        else if(status == 'REJECTED_CLOSE'){
          text = 'Từ chối đóng'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            show_hoan_thanh_lai = true;
            show_dong = true;
          }
          if(created_by == this.$store.getters.user){ 
            show_hoan_thanh_lai = true;
            show_dong = true;
          }
          show_tai = true;
        }
        else if(status == 'CLOSE_WAITTING'){
          text = 'Chờ duyệt đóng ATW'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            // show_hoan_thanh_lai = true;
            show_duyet_dong = true;
          }else if(uid_c1 == this.$store.getters.user){
            show_duyet_dong = true;
          }
          if(created_by == this.$store.getters.user){ 
            // show_hoan_thanh_lai = true;
            show_duyet_dong = true;
          }
          show_tai = true;
        }
        else if(status == 'CLOSE_LV1'){
          text = 'Duyệt đóng 1 cấp'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            // show_hoan_thanh_lai = true;
            show_duyet_dong = true;
          }else if(uid_c2 == this.$store.getters.user){
            show_duyet_dong = true;
          }
          if(created_by == this.$store.getters.user){ 
            // show_hoan_thanh_lai = true;
            show_duyet_dong = true;
          }
          show_tai = true;
        }else if(status == 'CLOSE'){
          text = 'Đã đóng'
          show_tai = false;
        }
        else if(status == 'REJECTED'){
          text = 'Bị từ chối'
          if(type_login == this.$constants.TYPE_USER.SUPPER_ADMIN || type_login == this.$constants.TYPE_USER.COMPANY){
            // show_hoan_thanh_lai = true;
            show_edit = true;
          }
          if(created_by == this.$store.getters.user){ 
            // show_hoan_thanh_lai = true;
            show_edit = true;
          }
        }
        this.status_text = text
        this.show_edit = show_edit
        this.show_duyet_atw = show_duyet_atw
        this.show_rut = show_rut
        this.show_gia_han = show_gia_han
        this.show_tai = show_tai
        this.show_hoan_thanh = show_hoan_thanh
        this.show_duyet_gia_han = show_duyet_gia_han
        this.show_duyet_rut = show_duyet_rut
        this.show_duyet_hoan_thanh = show_duyet_hoan_thanh
        this.show_hoan_thanh_lai = show_hoan_thanh_lai
        this.show_chinh_sua = show_chinh_sua
        this.show_dong = show_dong
        this.show_duyet_dong = show_duyet_dong
    },
    async getData(id) {
        var token = this.$store.getters.token ? this.$store.getters.token : null
        if(token){
            const headers = {
            "Authorization": "Bearer "+token,
            };
            var {data} = await ApiRepository.post("/_api/atw/view_detail", {id: id, company_id: this.company_id}, {headers});
            var value = data.data;
            this.model = value;
        }
    },
    backToList(){
        this.$router.push({ path: '/admin/list-atw', query: {company_id: this.company_id} });
    },
    goEdit(){
        this.$router.push({ path: '/admin/list-atw/edit/'+this.view_id, query: {company_id: this.company_id} });
    },
    toggleIcon(key){
      if(key == 1){
        this.show_1 = !this.show_1
      }else if(key == 2){
        this.show_2 = !this.show_2
      }else if(key == 3){
        this.show_3 = !this.show_3
      }
    },
    async updateStatus(status,note=''){
        this.$commonFuction.is_loading(false);
        var objects = {
            id : this.view_id,
            status : status,
            note : note,
        }
        var that = this;
        var company_id = this.company.id ? this.company.id : null;
        objects.company_id = company_id
        var token = that.$store.getters.token ? that.$store.getters.token : null
        if(token){
            const headers = {
                "Authorization": "Bearer "+token,
            }; 
            await ApiRepository.post("/_api/atw/update_status", objects, {headers}).then(async function (response) {
                if (response.status === 200) {
                    that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
                    that.$commonFuction.is_loading(false);
                    that.reloadPage();
                }
            }).catch((err) => {
                if(err.response && err.response.data){
                    if(err.response.data.message == "CAN_NOT_UPDATE_STATUS"){
                        that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: "Lỗi cập nhật trạng thái!",
                        life: 3000
                        });
                    }
                    }else{
                    that.$toast.add({
                        severity: 'error',
                        summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
                        detail: err,
                        life: 3000
                    });
                }
                that.$commonFuction.is_loading(false);
            })
        }
    },
    reloadPage(){
        window.location.reload();
    },
    goPageAdd(key){
        console.log("key add",key)
        if(key == 'supplies_equipment'){
            key = 'equipment' //gán key ban đầu là thiết bị
        }
        this.$router.push({ path: '/admin/list-atw/detail/'+this.view_id, query: {company_id: this.company_id,tp:'add',k:key} });
    },
    goPageEdit(key,data = null){
        if(key == 'user'){
            this.$router.push({ path: '/admin/list-atw/detail/'+this.view_id, query: {company_id: this.company_id,tp:'edit',k:key,su_id:data.id} });
        }else if(key == 'supplies_equipment'){
            if(data.type == 'equipment'){
                key = 'equipment' //gán key ban đầu là thiết bị
            }else if(data.type == 'supplies'){
                key = 'supplies' //gán key ban đầu là vật tư
            }
            this.$router.push({ path: '/admin/list-atw/detail/'+this.view_id, query: {company_id: this.company_id,tp:'edit',k:key,sse_id:data.id} });
        }else{
            this.$router.push({ path: '/admin/list-atw/detail/'+this.view_id, query: {company_id: this.company_id,tp:'edit',k:key} });
        }
        
    },
    async downloadFiles(data_file) {
      // this.displayDialogDownload = false;
      // console.log("click",data_file)
      var files = [];
      if(data_file){
        data_file.map(m=>{
          files.push({download: m.url, filename: m.name});
        })
      }
      // console.log("files",files)
      this.download_files(files);
    },
    download_files(files) {
      function download_next(i) {
        if (i >= files.length) {
          return;
        }
        var a = document.createElement('a');
        a.href = files[i].download;
        a.target = '_parent';
        // Use a.download if available, it prevents plugins from opening.
        if ('download' in a) {
          a.download = files[i].filename;
        }
        // Add a to the doc for click to work.
        (document.body || document.documentElement).appendChild(a);
        if (a.click) {
          a.click(); // The click method is supported by most browsers.
        } else {
          jq(a).click(); // Backup using jquery
        }
        // Delete the temporary link.
        a.parentNode.removeChild(a);
        // Download the next file with a small timeout. The timeout is necessary
        // for IE, which will otherwise only download the first file.
        setTimeout(function() {
          download_next(i + 1);
        }, 500);
      }
      // Initiate the first download.
      download_next(0);
    },
    async getListHistory(){
      if (this.$commonFuction.isEmptyObject(this.company)) {
        return;
      }
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
            "Authorization": "Bearer "+token,
        }
        var list_hisory = []
        var list_show = []
        var showLoadMore = false
        await ApiRepository.post("/_api/atw/history_status", {id : this.view_id, company_id: this.company.id}, {headers}).then((res) => {
          var history = res.data.data.list
          for (let i = 0; i < history.length; i++) {
            const e = history[i];
            var text_status = ""
            var text_note = "Ghi chú: "
            if(e.status == 'WAITTING'){
              text_status = "Chờ duyệt"
            }else if(e.status == 'APPROVED_LV1'){
              text_status = "Duyệt cấp 1"
            }else if(e.status == 'APPROVED'){
              text_status = "Đã duyệt"
            }else if(e.status == 'EXTEND'){
              text_status = "Được gia hạn"
            }else if(e.status == 'REJECTED'){
              text_status = "Từ chối duyệt"
            }else if(e.status == 'REJECTED_CLOSE'){
              text_status = "Từ chối đóng"
            }else if(e.status == 'WITHDRAW'){
              text_status = "Rút giấy phép"
            }else if(e.status == 'EDIT'){
              text_status = "Chỉnh sửa"
            }else if(e.status == 'EXTEND_WAITTING'){
              text_status = "Chờ duyệt gia hạn"
              text_note = ""
            }else if(e.status == 'EXTEND_LV1'){
              text_status = "Đã duyệt gia hạn 1 cấp"
              text_note = ""
            }else if(e.status == 'EXTEND'){
              text_status = "Đã gia hạn"
              text_note = ""
            }else if(e.status == 'REJECTED_EXTEND'){
              text_status = "Từ chối gia hạn"
              text_note = ""
            }else if(e.status == 'WITHDRAW_WAITTING'){
              text_status = "Chờ duyệt rút giấy phép"
              text_note = "Lý do: "
            }else if(e.status == 'WITHDRAW_LV1'){
              text_status = "Đã duyệt rút 1 cấp"
              text_note = ""
            }else if(e.status == 'WITHDRAW'){
              text_status = "Rút giấy phép"
              text_note = ""
            }else if(e.status == 'REJECTED_WITHDRAW'){
              text_status = "Từ chối rút giấy phép"
              text_note = "Ghi chú: "
            }else if(e.status == 'DONE_WAITTING'){
              text_status = "Chờ duyệt hoàn thành"
              text_note = ""
            }else if(e.status == 'DONE_LV1'){
              text_status = "Đã duyệt hoàn thành 1 cấp"
              text_note = ""
            }else if(e.status == 'DONE'){
              text_status = "Hoàn thành và đánh giá"
              text_note = ""
            }else if(e.status == 'REJECTED_DONE'){
              text_status = "Từ chối hoàn thành"
              text_note = "Ghi chú: "
            }else if(e.status == 'CLOSE_WAITTING'){
              text_status = "Chờ duyệt đóng ATW"
              text_note = ""
            }else if(e.status == 'CLOSE_LV1'){
              text_status = "Duyệt đóng 1 cấp"
            }else if(e.status == 'CLOSE'){
              text_status = "Đã đóng"
            }else if(e.status == 'REJECTED_CLOSE'){
              text_status = "Từ chối đóng ATW"
              text_note = "Ghi chú: "
            }
            var text_date_name = ''
            var date = moment.tz(e.created_at, this.time_zone_local).format("DD/MM/yyyy HH:mm");
            var fullname = e.created_name ?? ''
            if(date){
              text_date_name = date
            }
            if(text_date_name !== ''){
              if(fullname !== ''){
                text_date_name += ' - '+fullname;
              }
            }else{
              text_date_name = fullname
            }
            var tmp = {
              id : e.id,
              status : e.status,
              text_status : text_status,
              text_date_name : text_date_name,
              note : e.note ? text_note+e.note : '',
            }
            if(i < 3){
              list_show.push(tmp)
            }
            if(i == 3){
              showLoadMore = true
            }
            list_hisory.push(tmp)
          }
        }).catch((err) => {
            console.log(err);
        })
        this.allEvents = list_hisory
        this.displayedEvents = list_show
        this.history_status = list_show
        this.showLoadMore = showLoadMore
      }
    },
    showduyetATW(){
      this.title_header_dialog = 'Duyệt giấy phép làm việc #'+this.code
      // if(this.uid_c2){
        //gửi yêu cầu cập nhật trạng thái
        this.data_status.status = "APPROVED"
        this.data_status.note = ''
        this.showduyet = true;
      // }
    },
    async DuyetATW(){
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        // status : 'APPROVED_LV1',
        note : '',
      }
      if(this.data_status.status == 'APPROVED'){
        if(this.status == "APPROVED_LV1"){
          object.status = "APPROVED"
        }else if(this.uid_c2){
          object.status = "APPROVED_LV1"
        }else{
          object.status = "APPROVED"
        }
      }else if(this.data_status.status == 'REJECTED'){
        object.status = "REJECTED"
        if(!this.data_status.note){
          alert('Vui lòng nhập lý do từ chối')
          this.$commonFuction.is_loading(false);
          return
        }
        object.note = this.data_status.note
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = {
          "Authorization": "Bearer "+token,
        };
        await ApiRepository.post("/_api/atw/update_status", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    clickApprove(){
      this.data_status.status = "APPROVED"
      this.data_status.note = ''
    },
    clickReject(){
      this.data_status.status = "REJECTED"
    },
    showGiaHan(){
      this.showGHDialog = true
      this.title_header_dialog_GH = 'Gia hạn giấy phép #'+this.code
    },
    saveGiaHan(){
      if(!this.expiration_date){
        alert("Vui lòng chọn ngày gia hạn")
        return
      }
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        extend_date : moment(this.expiration_date).format("YYYY-MM-DD"),
        status : 'EXTEND_WAITTING',
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/update_expiration", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.showGHDialog = false;
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    goCheck(){
      alert("Đang phát triển")
    },
    checkGiamSat(ids){
      var id = this.$store.getters.user ?? null
      if(ids.includes(id)){
        return true
      }
      return false
    },
    showDuyetGiaHan(){
      this.title_duyet_gia_han = 'Duyệt gia hạn #'+this.code
      this.data_status.status = "APPROVED"
      this.data_status.note = ''
      this.showduyetgiahanDialog = true;
    },
    SaveDuyetGiaHan(){
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        status : '',
        note : '',
        extend_date : this.extend_date_show ? moment(this.extend_date_show).format("YYYY-MM-DD") : null
      }
      if(this.data_status.status == 'APPROVED'){
        if(this.status == "EXTEND_LV1"){//đã duyệt cấp 1
          object.status = "EXTEND"
        }else if(this.uid_c2){//tồn tại 2 cấp duyệt
          object.status = "EXTEND_LV1"
        }else{//duyết 1 cấp
          object.status = "EXTEND"
        }
      }else if(this.data_status.status == 'REJECTED'){
        object.status = "REJECTED_EXTEND"
        if(!this.data_status.note){
          alert('Vui lòng nhập lý do từ chối')
          this.$commonFuction.is_loading(false);
          return
        }
        object.note = this.data_status.note
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/update_expiration", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.showGHDialog = false;
            that.$commonFuction.is_loading(false);
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    goEvaluate(){
      this.$router.push({ path: '/admin/list-atw/detail/'+this.view_id, query: {company_id: this.company_id} });
    },
    showRutGiayPhep(){
      this.note_rut = ''
      this.title_header_dialog_RGP = 'Rút giấy phép #'+this.code
      this.showRGPDialog = true
    },
    saveRut(){
      var note_rut = this.note_rut ?? ''
      if(!note_rut){
        alert("Vui lòng nhập lý do rút giấy phép")
        return
      }
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        status : 'WITHDRAW_WAITTING',
        note : note_rut,
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/update_withdraw", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.showRGPDialog = false;
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    showDuyetRut(){
      this.title_duyet_rut = 'Duyệt rút giấy phép #'+this.code
      this.data_status.status = "APPROVED"
      this.data_status.note = ''
      this.showduyetrutDialog = true;
    },
    SaveDuyetRut(){
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        status : '',
        note : '',
      }
      if(this.data_status.status == 'APPROVED'){
        if(this.status == "WITHDRAW_LV1"){//đã duyệt cấp 1
          object.status = "WITHDRAW"
        }else if(this.uid_c2){//tồn tại 2 cấp duyệt
          object.status = "WITHDRAW_LV1"
        }else{//duyết 1 cấp
          object.status = "WITHDRAW"
        }
      }else if(this.data_status.status == 'REJECTED'){
        object.status = "REJECTED_WITHDRAW"
        if(!this.data_status.note){
          alert('Vui lòng nhập lý do từ chối')
          this.$commonFuction.is_loading(false);
          return
        }
        object.note = this.data_status.note
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/update_withdraw", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.showGHDialog = false;
            that.$commonFuction.is_loading(false);
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    showDuyetHoanThanh(){
      this.title_duyet_hoan_thanh = 'Duyệt hoàn thành #'+this.code
      this.data_status.status = "APPROVED"
      this.data_status.note = ''
      this.showduyethoanthanhDialog = true;
    },
    SaveDuyetHoanThanh(){
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        status : '',
        note : '',
      }
      if(this.data_status.status == 'APPROVED'){
        if(this.status == "DONE_LV1"){//đã duyệt cấp 1
          object.status = "DONE"
        }else if(this.uid_c2){//tồn tại 2 cấp duyệt
          object.status = "DONE_LV1"
        }else{//duyết 1 cấp
          object.status = "DONE"
        }
      }else if(this.data_status.status == 'REJECTED'){
        object.status = "REJECTED_DONE"
        if(!this.data_status.note){
          alert('Vui lòng nhập lý do từ chối')
          this.$commonFuction.is_loading(false);
          return
        }
        object.note = this.data_status.note
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/evaluate_approved", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.showGHDialog = false;
            that.$commonFuction.is_loading(false);
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    showDong(){
      this.title_header_dialog_dong = 'Đóng ATW #'+this.code
      this.showdongDialog = true;
    },
    saveDong(){
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        status : 'CLOSE_WAITTING',
        note : '',
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/update_close", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    showDuyetDong(){
      this.title_header_dialog_duyet_dong = 'Duyệt đóng #'+this.code
      this.data_status.status = "APPROVED"
      this.data_status.note = ''
      this.showduyetdongDialog = true;
    },
    saveDuyetDong(){
      this.$commonFuction.is_loading(true);
      var object = {
        id : this.view_id,
        company_id : this.company.id,
        status : '',
        note : '',
      }
      if(this.data_status.status == 'APPROVED'){
        if(this.status == "CLOSE_LV1"){//đã duyệt cấp 1
          object.status = "CLOSE"
        }else if(this.uid_c2){//tồn tại 2 cấp duyệt
          object.status = "CLOSE_LV1"
        }else{//duyết 1 cấp
          object.status = "CLOSE"
        }
      }else if(this.data_status.status == 'REJECTED'){
        object.status = "REJECTED_CLOSE"
        if(!this.data_status.note){
          alert('Vui lòng nhập lý do từ chối')
          this.$commonFuction.is_loading(false);
          return
        }
        object.note = this.data_status.note
      }
      var that = this;
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        const headers = { "Authorization": "Bearer "+token, };
        ApiRepository.post("/_api/atw/update_close", object, {headers}).then((response) => {
          if (response.status === 200) {
            that.$toast.add({ severity: 'success', summary: 'Thành công', detail: 'Lưu dữ liệu thành công', life: 3000 })
            that.$commonFuction.is_loading(false);
            that.reloadPage()
          } else {
            that.$toast.add({ 
              severity: 'error',
              summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
              detail: response.data.message,
              life: 3000
            });
            that.$commonFuction.is_loading(false);
          }
        }).catch((err) => {
          that.$toast.add({
            severity: 'error',
            summary: that.$constants.MSG_TEXT.TITLE_ERR_DIALOG,
            detail: err,
            life: 3000
          });
          that.$commonFuction.is_loading(false);
        })
      }else{
        this.$commonFuction.is_loading(false);
      }
    },
    showAllEvents(){
      this.history_status = JSON.parse(JSON.stringify(this.allEvents))
      this.showLoadMore = false
    },
    showDisplayEvents(){
      this.history_status = JSON.parse(JSON.stringify(this.displayedEvents))
      this.showLoadMore = true
    },
    async DownloadPDF(){
      var token = this.$store.getters.token ? this.$store.getters.token : null
      if(token){
        this.$commonFuction.is_loading(true);
        const headers = { "Authorization": "Bearer "+token};
        var {data} = await ApiRepository.post("/_api/atw/download_gp_pdf", {id: this.view_id, company_id: this.company.id}, {headers});
        var value = data.data;
        console.log("value=====",value)
        if(value){
          var a = document.createElement('a');
          a.href = value.fileUrl;
          a.download = value.fileName;
          a.target = '_blank';
          // Use a.download if available, it prevents plugins from opening.
          if ('download' in a) {
            a.download = value.fileName;
          }
          // Add a to the doc for click to work.
          (document.body || document.documentElement).appendChild(a);
          if (a.click) {
            a.click(); // The click method is supported by most browsers.
          } else {
            jq(a).click(); // Backup using jquery
          }
          // Delete the temporary link.
          a.parentNode.removeChild(a);
        }
        this.$commonFuction.is_loading(false);
      }
    },
    formatTextToHtml(text){
        if(text){
            return text.replace(/(?:\r\n|\r|\n)/g, '<br>');
        }
        return '';
    }
  }

  
}
</script>
<style lang="scss">
  .manager-title-custom{
    color: #1D3118;
    font-size: 18px;
    margin-bottom: 16px;
    padding-bottom: 10px;
    border-bottom: 1px solid #EEEEEE;
    font-weight: 700;
  }
    .tab {
        display: flex;
        font-weight: 700;
        border-bottom: 1px solid #00000029;
    }
    .tab div {
        padding: 6px 8px;
        /* margin-right: 2px; */
        cursor: pointer;
    }
    .tab div.active {
        background-color: #fff;
        color: #0086C4;
        border-left: 1px solid #0086C4;
        border-right: 1px solid #0086C4;
        border-bottom: 3px solid #0086C4;
        border-top: 1px solid #0086C4;
    }
    .content {
        padding-top: 10px;
        display: none;
    }
    .content.active {
        display: block;
    }
    .button-container {
        display: flex;
        justify-content: flex-end; /* Căn chỉnh các nút về bên phải */
    }
    .button-container button {
        width: auto !important;
        margin-left: 5px; /* Khoảng cách giữa các nút */
    }
    .p-button-disa {
        color : #666666;
        background-color : #F2F3F7;
        border: 1px solid #F2F3F7;
    }
    .p-button-disa:hover {
        background-color: #F2F3F7 !important;
        border: 1px solid #F2F3F7 !important;
        color : #666666 !important;
    }
    .row-cs {
        padding-top : 6px;
    }
    .f-cus {
        color : #0086C4;
        font-weight: 700;
        font-size: 18px;
    }
    .title-css { 
  font-weight: bold;
}
.drop-cus {
  border: 1px solid #ccc;
  border-radius: 8px;
  padding: 10px;
}
.accordion-item {
  border: 1px solid #ddd;
  border-radius: 5px;
}
.accordion-label {
  display: block;
  padding: 8px;
  background-color: #DFE2E6;
  /* font-size: 15px; */
  font-weight: bold;
  cursor: pointer;
}
.accordion-content {
  margin-bottom: 5px;
}
.f-grid-v {
  display: flex;
  justify-content: space-between;
  flex-flow: row wrap;
  padding: 5px;
}
.f-grid-col-v {
  flex: 1 0;
  background-color: #F8F9FB;
  padding: 0px 10px 10px 10px;
  border-radius: 5px;
  margin: 5px 5px 5px 5px;
}
.left-cs {
    text-align: left;
    font-weight: bold;
    width: 120px;
    min-width: 120px;
}
.right-cs {
    text-align: right;
}
.left-cs-2 {
    text-align: left;
    font-weight: bold;
    width: 130px;
}
.container-tpl {
    display: flex; /* Sử dụng Flexbox để chia thành 2 phần */
    justify-content: space-between; /* Căn chỉnh nội dung sang hai bên */
    /* align-items: center; */
    padding-top : 5px;
}
.titel-cs {
    font-weight: bold;
}
.f-grid-col-v2 {
  background-color: #F8F9FB;
  padding: 0px 10px 5px 10px;
  border-radius: 5px;
  margin: 
  5px 10px 5px 10px;
}
.container-tpl-v2 {
    padding-top : 0px;
}

.pad-cus {
    padding-top: 2px;
    padding-bottom: 2px;
}
.container-tpl-vt {
    display: flex;
}
.cl-other {
    min-width: 37px;
}

#yc_nhathau_tab {
  /* font-family: Arial, Helvetica, sans-serif; */
  border-collapse: collapse;
  width: 100%;
}

.download-file-cs {
  color : #0086C4;
  text-decoration: underline;
  cursor: pointer;
}

.status-approved {
  color: #00973C;
  font-weight: bold;
}
.status-rejected {
  color: #F5564E;
  font-weight: bold;
}
.span-link{
    color: #0086C4;
    cursor: pointer;
}
.css-underline {
    text-decoration: underline;
}
#status_history .p-timeline-event-marker {
  background-color : #D0D4D9 !important;
}
#status_history .p-timeline-event-opposite{
  display : none !important;
}
#status_history .p-timeline-event {
  min-height : 36px !important
}
#status_history .p-timeline-event-content {
  padding: 0px 0px 4px 10px;
} 
.text-status-first {
  font-weight: 800;
  color: #0086C4;
}
.text-status {
  font-weight: 800;
  color: #666666;
  margin-top: -3px;
}
.text-date-name { 
  color : #666666;
}
.active-cus {
  font-size: 10px;
  font-weight: bold;
  box-shadow: 0px 0px 10px 2px #0086C4;
  border-radius: 50%;
  border-color: #0086C4;
  color: transparent;
  border: 1px solid #0086C4;
}
.p-button-disa {
    color : #666666;
    background-color : #F2F3F7;
    border: 1px solid #F2F3F7;
}
.p-button-disa:hover {
    background-color: #F2F3F7 !important;
    border: 1px solid #F2F3F7 !important;
    color : #666666 !important;
}
.custom-dialog {
  width: 500px;
  max-width: 500px;
}
.class-btn-duyet{
  
}
.cs-div-dialog {
  padding-bottom: 5px;
}

#tb_dg {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#tb_dg td {
  border: 1px solid #ddd;
  padding: 6px;
  width: 33.33%;
}
#tb_dg th {
  border: 1px solid #ddd;
  padding-top: 6px;
  padding-bottom: 6px;
  text-align: left;
  padding-left: 5px;
  width: 33.33%;
}
.danhgianote-cs {
    font-weight: bold;
    width: 120px;
    min-width: 120px;
}
</style>